import {Component} from "@angular/core";

@Component({
    selector: "fui-modal-window-content",
    styleUrls: ["./modal-window-content.component.scss"],
    templateUrl: "./modal-window-content.component.html",
    standalone: false
})
export class FUIModalWindowContentComponent {
    constructor() {

    }
}
